import { useReadQuery } from '@apollo/client'
import { useLoaderData } from 'react-router-typesafe'
import { TopLosersTable } from '../../top-losers/TopLosersTable'
import { CoinPageLoader } from '../CoinPage'
import { TopLosersCardLayout } from './TopLosersCardLayout'

export function TopLosersCard() {
  const queryRef = useLoaderData<CoinPageLoader>()
  const { data } = useReadQuery(queryRef)
  if (!data.coinBySymbol) return null
  return (
    <TopLosersCardLayout
      content={
        <TopLosersTable
          query={data.coinBySymbol.date.topLosers}
          bip44_symbol={data.coinBySymbol.bip44_symbol}
          limit={5}
        />
      }
    />
  )
}
